import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import 'moment-timezone';
import * as lodash from 'lodash';
import { LoDashStatic } from 'lodash';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import * as CryptoJS from 'crypto-js';  

export class RequestHelper {
    constructor(private httpClient: HttpClient) { }

    public httpGet<T>(api: string,queryParams?:any): Observable<T> {
        if(queryParams != null){
            return this.httpClient.get(api,{params:queryParams}).pipe(
                map(result => result as T)
            );
        }
        return this.httpClient.get(api).pipe(
            map((result => result as T))
        );
    }

    public httpPost<T>(api: string, payload?: any): Observable<T> {
        return this.httpClient.post(api, payload).pipe(
            map(result => result as T)
        );
    }

    public httpPut<T>(api: string, payload?: any): Observable<T> {
        return this.httpClient.put(api, payload).pipe(
            map(result => result as T)
        );
    }

    public httpPatch<T>(api: string, payload?: any): Observable<T> {
        return this.httpClient.patch(api, payload).pipe(
            map(result => result as T)
        );
    }

    public httpDelete<T>(api: string): Observable<T> {
        return this.httpClient.delete(api).pipe(
            map(result => result as T)
        );
    }
}

@Injectable({
    providedIn: 'root'
})
export class UtilitiesService {
    moment = moment;
    _: LoDashStatic;
    req: RequestHelper;

    constructor(private httpClient: HttpClient, private translateService: TranslateService) {
        // this._ = lodash;
        this.req = new RequestHelper(httpClient);
    }

    public orderByNumberString(input: any[], key: string): any[] {
        return this._.sortBy(input, (obj) => {
            if (isNaN(obj[key])) {
                return obj[key];
            } else {
                return parseInt(obj[key], 10);
            }
        });
    }

    isEquivalentObjs(objA: any, ObjB: any): boolean {
        const aProps = Object.getOwnPropertyNames(objA);
        const bProps = Object.getOwnPropertyNames(ObjB);
        if (aProps.length !== bProps.length) {
            return false;
        }
        aProps.forEach(aProp => {
            const propName = aProp;
            if (objA[propName] !== ObjB[propName]) {
                return false;
            }
        });
        return true;
    }

    public calculateScore(actual: number, target: number): number {
        if (target === 0) {
            return 0;
        }
        if (actual >= target) {
            return 100;
        }
        return Math.floor((actual / target) * 100);
    }

    public encrypt(payload: string): string {
        const iv = CryptoJS.lib.WordArray.random(128/8).toString(CryptoJS.enc.Hex);
        const salt = CryptoJS.lib.WordArray.random(128/8).toString(CryptoJS.enc.Hex);
        const keySize = 128 / 32;

        var key = CryptoJS.PBKDF2('fd2be2b8-de03-4899-86e6-e6690d2662dd', CryptoJS.enc.Hex.parse(salt), { keySize: keySize, iterations: 1000 });
        var encrypted = CryptoJS.AES.encrypt(payload, key, { iv: CryptoJS.enc.Hex.parse(iv) });
        var ciphertext = encrypted.ciphertext.toString(CryptoJS.enc.Base64);
        return iv + "::" + salt + "::" + ciphertext;
    }

}
